// src/pages/returnToVendor/ReturnToVendorA4Document.jsx
import React from 'react';
import { useLocalization } from '../../contexts/LocalizationContext';
import { formatCurrency } from '../../utils/orderCalculations';
import A4DocumentLayout from '../../components/common/A4DocumentLayout/A4DocumentLayout';
import A4ProductCell from '../../components/common/A4DocumentLayout/A4ProductCell';

const itemName = (item) => {
  const product = item.Product;
  const variation = item.ProductVariation;
  if (!product) return `Item #${item.grnItemId}`;
  return `${product.name}${variation?.sku ? ` — ${variation.sku}` : ''}`;
};

const ReturnToVendorA4Document = ({ rtv }) => {
  const { t } = useLocalization();

  if (!rtv) return null;

  return (
    <A4DocumentLayout
      title={t('returnToVendor.rtvNumber')}
      subtitle={t('returnToVendor.returnToVendorDetails')}
      documentNumber={`#${rtv.rtvNumber}`}
      metaRows={[
        { label: t('common.created'), value: new Date(rtv.createdAt).toLocaleString() },
        { label: t('common.status'), value: (rtv.status || '').toUpperCase() },
      ]}
      infoCards={[
        {
          title: t('returnToVendor.purchaseOrderNumber'),
          primary: `#${rtv.purchaseOrder?.purchaseOrderNumber || t('common.na')}`,
          lines: [
            `${t('returnToVendor.supplier')}: ${rtv.supplier?.name || rtv.Supplier?.name || t('common.na')}`,
            `${t('returnToVendor.grnNumber')}: #${rtv.goodsReceivedNote?.grnNumber || t('common.na')}`,
          ],
        },
        {
          title: t('returnToVendor.totalDebitAmount'),
          primary: formatCurrency(rtv.totalDebitAmount),
          lines: (rtv.debitNotes || []).length
            ? [`${t('returnToVendor.linkedDebitNotes')}: ${rtv.debitNotes.map((d) => d.debitNoteNumber).join(', ')}`]
            : [],
        },
      ]}
      items={{
        columns: [
          { header: '#', align: 'center', width: '40px' },
          { header: t('returnToVendor.item') },
          { header: t('returnToVendor.warehouse') },
          { header: t('returnToVendor.quantityReturned'), align: 'center' },
          { header: t('returnToVendor.unitPriceLabel'), align: 'right' },
          { header: t('returnToVendor.lineAmount'), align: 'right' },
        ],
        rows: (rtv.items || []).map((item, index) => [
          index + 1,
          <A4ProductCell
            item={item}
            name={item.Product?.name || itemName(item)}
            sku={item.ProductVariation?.sku || item.Product?.sku}
          />,
          item.returnFromWarehouse?.name || t('common.na'),
          item.quantityReturned,
          formatCurrency(item.unitPrice),
          formatCurrency(item.lineAmount),
        ]),
      }}
      summary={rtv.reason ? { notes: { label: t('returnToVendor.reason'), text: rtv.reason } } : undefined}
      footerNote="This is a computer-generated return to vendor note."
    />
  );
};

export default ReturnToVendorA4Document;
